import { h } from 'vue'
import type { FunctionalComponent } from 'vue'

// SFCs (`a`, `game-list`) are merged in Details.vue — a .ts file cannot import .vue.
const native = (tag: string): FunctionalComponent => (_props, { attrs, slots }) => h(tag, attrs, slots.default?.())

export const nativeBlogComponents = {
    p: native('p'),
    strong: native('strong'),
    em: native('em'),
    u: native('u'),
    ul: native('ul'),
    ol: native('ol'),
    li: native('li'),
    br: native('br'),
    h2: native('h2'),
    h3: native('h3'),
    table: native('table'),
    thead: native('thead'),
    tbody: native('tbody'),
    tr: native('tr'),
    th: native('th'),
    td: native('td'),
}
